export const apiName: string = 'localidades';
export const localidadesRoute: string = 'localidades';
export const localidadesStorage: string = 'localidades';
export const localidadesModuleName: any = {plural: 'Localidades', single: 'Localidade'};


export const localidadesQuery: any = {
  "where":{
    "ativo":true,
    "localidade":{"regexp":"/REPLACEHERE/i"}
  },
  "order":"localidade"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/shared/data.service.ts
 **/